
import { MatPaginatorIntl } from '@angular/material/paginator';

export class CustomMatPaginatorIntl extends MatPaginatorIntl {
  override itemsPerPageLabel = 'Per Page'; // 👈 Your custom label

  override nextPageLabel = 'Next';
  override previousPageLabel = 'Previous';

  override getRangeLabel = (page: number, pageSize: number, length: number): string =>{
    if (length === 0 || pageSize === 0) {
      return `0 of ${length}`;
    }
    const startIndex = page * pageSize;
    const endIndex = Math.min(startIndex + pageSize, length);
    return `${startIndex + 1} – ${endIndex} of ${length}`;
  }
}

